<div class="app-layout" [class.sidebar-collapsed]="isSidebarCollapsed">
  <aside class="sidebar">
    <div class="logo-area">
      <img src="assets/logo.png" alt="بنك الشفاء المصري" class="brand-logo">
      <div class="logo-text" *ngIf="!isSidebarCollapsed">بنك الشفاء المصري</div>
      <div class="logo-tagline" *ngIf="!isSidebarCollapsed">معاً.. لإنقاذ حياة</div>
    </div>
    <nav class="nav-links">
      <a routerLink="/dashboard" routerLinkActive="active" class="nav-item">
        <span class="material-icons">dashboard</span>
        <span class="nav-text" *ngIf="!isSidebarCollapsed">لوحة القيادة</span>
      </a>
      <a routerLink="/donors" routerLinkActive="active" class="nav-item">
        <span class="material-icons">people</span>
        <span class="nav-text" *ngIf="!isSidebarCollapsed">المتبرعون</span>
      </a>
      <a routerLink="/pledges" routerLinkActive="active" class="nav-item">
        <span class="material-icons">volunteer_activism</span>
        <span class="nav-text" *ngIf="!isSidebarCollapsed">قسم التحصيلات</span>
      </a>
      <a routerLink="/operations/transfers" routerLinkActive="active" class="nav-item">
        <span class="material-icons">swap_horiz</span>
        <span class="nav-text" *ngIf="!isSidebarCollapsed">التعديلات والتحويلات</span>
      </a>
      <a routerLink="/campaigns" routerLinkActive="active" class="nav-item">
        <span class="material-icons">campaign</span>
        <span class="nav-text" *ngIf="!isSidebarCollapsed">الحالات الطارئة</span>
      </a>
      <a routerLink="/financial" routerLinkActive="active" class="nav-item">
        <span class="material-icons">account_balance</span>
        <span class="nav-text" *ngIf="!isSidebarCollapsed">الإدارة المالية</span>
      </a>
      <a routerLink="/reports" routerLinkActive="active" class="nav-item">
        <span class="material-icons">assessment</span>
        <span class="nav-text" *ngIf="!isSidebarCollapsed">التقارير</span>
      </a>
    </nav>
  </aside>
  
  <div class="main-content">
    <header class="top-header">
      <div class="header-left">
        <button class="toggle-btn" (click)="toggleSidebar()">
          <span class="material-icons">menu</span>
        </button>
      </div>
      <div class="header-right">
        <!-- Notifications Dropdown -->
        <div class="dropdown-container">
          <div class="notification-bell" (click)="toggleNotifications()">
            <span class="material-icons">notifications</span>
            <span class="unread-dot" *ngIf="(unreadCount$ | async) as unreadCount">
              <span *ngIf="unreadCount > 0">{{ unreadCount }}</span>
            </span>
          </div>
          
          <div class="dropdown-menu notifications-menu glass-card" *ngIf="isNotificationsOpen">
            <div class="dropdown-header">
              <h3>الإشعارات</h3>
            </div>
            <div class="dropdown-body">
              <div class="notification-item" 
                   *ngFor="let notif of notifications$ | async" 
                   [class.unread]="!notif.isRead"
                   (click)="markAsRead(notif.id)">
                <div class="notif-icon" [ngClass]="notif.type.toLowerCase()">
                  <span class="material-icons">
                    {{ notif.type === 'INFO' ? 'info' : 
                       notif.type === 'WARNING' ? 'warning' : 
                       notif.type === 'SUCCESS' ? 'check_circle' : 'error' }}
                  </span>
                </div>
                <div class="notif-content">
                  <h4>{{ notif.title }}</h4>
                  <p>{{ notif.message }}</p>
                </div>
                <button class="delete-notif-btn" (click)="removeNotification(notif.id, $event)">
                  <span class="material-icons">close</span>
                </button>
              </div>
              <div class="empty-state" *ngIf="(notifications$ | async)?.length === 0">
                لا توجد إشعارات جديدة
              </div>
            </div>
          </div>
        </div>

        <!-- User Profile Dropdown -->
        <div class="dropdown-container profile-container">
          <div class="user-profile" (click)="toggleProfileMenu()" *ngIf="currentUser$ | async as user">
            <div class="avatar" *ngIf="!user.avatarUrl">{{ user.fullName.charAt(0) }}</div>
            <img [src]="user.avatarUrl" *ngIf="user.avatarUrl" class="avatar-img" alt="User Avatar">
            <span class="user-name">{{ user.fullName }}</span>
            <span class="material-icons">expand_more</span>
          </div>

          <div class="dropdown-menu profile-menu glass-card" *ngIf="isProfileMenuOpen && (currentUser$ | async) as user">
            <div class="dropdown-header user-info-header">
              <div class="user-info-avatar">{{ user.fullName.charAt(0) }}</div>
              <div class="user-info-details">
                <h4>{{ user.fullName }}</h4>
                <p>رقم المتعرف: {{ user.id }}</p>
              </div>
            </div>
            <div class="dropdown-divider"></div>
            <a routerLink="/settings" class="dropdown-item" (click)="isProfileMenuOpen = false">
              <span class="material-icons">settings</span>
              <span>إعدادات الحساب</span>
            </a>
            <div class="dropdown-divider"></div>
            <button class="dropdown-item text-danger" (click)="logout()">
              <span class="material-icons">logout</span>
              <span>تسجيل الخروج</span>
            </button>
          </div>
        </div>
      </div>
    </header>
    
    <main class="content-area">
      <router-outlet></router-outlet>
    </main>
  </div>

  <!-- Global Toast Notification -->
  <div class="toast-container" *ngIf="activeToast">
    <div class="toast glass-card animate-slide-in">
      <div class="notif-icon" [ngClass]="activeToast.type.toLowerCase()">
        <span class="material-icons">
          {{ activeToast.type === 'INFO' ? 'info' : 
             activeToast.type === 'WARNING' ? 'warning' : 
             activeToast.type === 'SUCCESS' ? 'check_circle' : 'error' }}
        </span>
      </div>
      <div class="notif-content">
        <h4>{{ activeToast.title }}</h4>
        <p>{{ activeToast.message }}</p>
      </div>
    </div>
  </div>

</div>
